module.exports = __webpack_public_path__ + "static/media/manage-campaigns-icon.52dfa075.svg";